export default function Breadcrumb(props) {
    const {title} = props

    return (
        <>
            <div className="d-none d-lg-block">
                <div className="bg-integral">
                    <div className="container space-1 space-top-lg-2 space-bottom-lg-3">
                        <div className="row align-items-center">
                            <div className="col">
                                <h1 className="h2 text-white text-light">{title}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
